var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useMemo } from 'react';
import { transformAdditionalProducts, transformOfferContents, transformSalePackageLinks, } from '@r1-frontend/ui-react/components/TariffCard/helpers';
import { RubleSymbol } from '@r1-frontend/ui-react/tokens/symbols';
import { btnTypes } from '../buttons/baseButton';
import InternetBlock from './internetBlock';
import Subscriptions from './subscriptions';
import TvBlock from './tvBlock';
import * as ST from './styled';
var TariffCard = function (_a) {
    var tariff = _a.tariff, _b = _a.openModal, openModal = _b === void 0 ? function () { return ({}); } : _b, _c = _a.tiled, tiled = _c === void 0 ? false : _c, background = _a.background, hasUrlBackground = _a.hasUrlBackground, withSubscriptions = _a.withSubscriptions, tvData = _a.tvData, internetData = _a.internetData, promoPeriod = _a.promoPeriod, buttonText = _a.buttonText, onClickHandler = _a.onClickHandler, buyTypePopup = _a.buyTypePopup, isOpenInternet = _a.isOpenInternet, onToggleHandler = _a.onToggleHandler;
    var _d = tariff.analog, analog = _d === void 0 ? 0 : _d, colorText = tariff.colorText, description = tariff.description, _e = tariff.hdCount, hdCount = _e === void 0 ? 0 : _e, offerContents = tariff.offerContents, price = tariff.price, priceAction = tariff.priceAction, _f = tariff.sdCount, sdCount = _f === void 0 ? 0 : _f, speed = tariff.speed, title = tariff.title, _g = tariff.titleColors, titleColors = _g === void 0 ? [] : _g, salePackageLinks = tariff.salePackageLinks, additionalProducts = tariff.additionalProducts;
    var preparedSubscriptions = useMemo(function () {
        var offerData = transformOfferContents(offerContents);
        var subscriptionData = transformSalePackageLinks(salePackageLinks);
        var additionalProductData = transformAdditionalProducts(additionalProducts);
        return __spreadArray(__spreadArray([], ((subscriptionData && subscriptionData.length)
            ? subscriptionData
            : offerData), true), (additionalProductData !== null && additionalProductData !== void 0 ? additionalProductData : []), true);
    }, [offerContents, salePackageLinks, additionalProducts]);
    var totalChannels = useMemo(function () { return hdCount + sdCount + analog; }, [hdCount, sdCount, analog]);
    var getLocalePrice = useCallback(function (price) { return price.toLocaleString('ru-RU', { maximumFractionDigits: 0 }) + " ".concat(RubleSymbol, "/\u043C\u0435\u0441"); }, []);
    return (<>
            <ST.CardWrapper tiled={tiled}>
                <ST.ContentSection bg={background} colorText={colorText}>
                    <ST.TariffTitle colors={titleColors} withBg={hasUrlBackground} data-test='card-title'>
                        {title}
                    </ST.TariffTitle>

                    <ST.TariffDescription data-test='tariff-desc'>{description}</ST.TariffDescription>

                    {withSubscriptions && <Subscriptions subscriptions={preparedSubscriptions} data-test='tariff-subs'/>}

                    <ST.ServicesSection withSubs={withSubscriptions}>
                        {!!speed && (<InternetBlock isAccordion={withSubscriptions && !!tvData.length} withBg={hasUrlBackground} isOpen={isOpenInternet} onToggle={onToggleHandler} speed={speed} advantages={internetData}/>)}
                        {!!totalChannels && (<TvBlock isAccordion={withSubscriptions && !!(internetData === null || internetData === void 0 ? void 0 : internetData.length)} withBg={hasUrlBackground} isOpen={!isOpenInternet} onToggle={onToggleHandler} totalChannels={totalChannels} tvDescriptions={tvData} openPopup={function () { return openModal(tariff); }}/>)}
                    </ST.ServicesSection>
                </ST.ContentSection>

                <ST.PriceSection>
                    {priceAction
            ? <>
                            <ST.PricesBlock>
                                <ST.TariffPrice data-test='promo-price'>
                                    {getLocalePrice(priceAction)}
                                </ST.TariffPrice>
                                <ST.OldPrice>{getLocalePrice(price)}</ST.OldPrice>
                            </ST.PricesBlock>
                            {promoPeriod && <ST.ActionLabel>цена на {promoPeriod}</ST.ActionLabel>}
                        </>
            : <ST.PricesBlock>
                            <ST.TariffPrice data-test='price'>
                                {getLocalePrice(price)}
                            </ST.TariffPrice>
                        </ST.PricesBlock>}
                    <ST.StyledBaseButton type={btnTypes.SECONDARY} text={buttonText} onClick={onClickHandler} data-test='connect-btn'/>
                </ST.PriceSection>
            </ST.CardWrapper>
            {!!buyTypePopup && buyTypePopup}
        </>);
};
export default TariffCard;
